(function ($, lo, eventHub) {
	'use strict';
	var templateHTML = '<div class="<%=classPrefix%> tbl suggested-points noselect">' +
		'<div class="trow">' +
		'<div class="tcell spoint" data-value="20">£20</div>' +
		'<div class="tcell spoint selected" data-value="50">£50</div>' +
		'<div class="tcell spoint" data-value="100">£100</div>' +
		'</div>' +
		'</div>';

	var pluginName = 'suggestTable';
	var ghostClickElapsedTime = 50;
	var _lastEventTimestamp = 0;
	var defaults = {
		eventName           : 'select-sp',
		currency            : '',
		thousandsSeparator  : ',',
		order               : 'none', // 'asc', 'desc',
		currencyMap         : {
			'eur' : '€', 'usd' : '$', 'gbp' : '£', 'yen' : '¥', 'ils' : '₪', 'inr' : '₹', 'rub' : '₽', 'try' : '₺', 'cny' : '¥', 'krw' : '₩', 'zar' : 'R', 'brl' : 'R$'
		},
		skeletonTemplate    : templateHTML,
		classPrefix         : 'stp',
		showCurrency        : true,
		currencySeparator   : '',
		pointsPerRow		: 3,
		getIntlNumberFormatter : false,
		getCurrencyFormatter   : function (currencyMap, currencySeparator) {
			return function (currency, value) {
				if (currencyMap[currency.toLowerCase()]) {
					return currencyMap[currency.toLowerCase()] + currencySeparator + value;
				}
				return value + "&nbsp;" + currency.toUpperCase();
			};
		},
		getNumberFormatter   : function (thousandsSeparator) {
			return function (number, currency) {
				return number.toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1' + thousandsSeparator);
			};
		},
		onChange            : function (oldVal, newVal) {
			return oldVal + newVal;
		}
	};

	function Plugin(element, options) {
		this.element = element;
		this.value = null;
		this.options = $.extend(true, {}, defaults, options);
		if (this.options.getIntlNumberFormatter && typeof this.options.getIntlNumberFormatter == 'function') {
			this.formatter = this.options.getIntlNumberFormatter();
		} else {
			var baseCurrencyFormatter = this.options.getCurrencyFormatter(this.options.currencyMap, this.options.currencySeparator);
			var baseNumberFormatter = this.options.getNumberFormatter(this.options.thousandsSeparator);
			this.formatter = {
				formatDecimal  : baseNumberFormatter,
				formatCurrency : function adapter(amount, currency) {
					return baseCurrencyFormatter(currency, baseNumberFormatter(amount, currency));
				}
			};
		}
		this.template = lo.template(this.options.skeletonTemplate);
		if (options && options.parser) {
			if (lo.isFunction(options.parser)) {
				this.parser = options.parser;
			}
		} else {
			this.parser = function (data) {
				return data;
			};
		}
		this.init();
	}

	Plugin.prototype.init = function () {
		this.classPrefix = lo.escape(this.options.classPrefix);
		this.listElm = $(this.template(this.options));
		$(this.element).empty().append(this.listElm);
		var self = this;
		this.listElm.on('click tap', '.tcell', function () {
			var currentTime = (new Date()).getTime();
			if (currentTime - _lastEventTimestamp < ghostClickElapsedTime) {
				_lastEventTimestamp = currentTime;
				return true;
			}
			self.listElm.find('.tcell').removeClass('selected');
			$(this).addClass('selected');
			self.options.onChange(self.value, $(this).data('value'));
			self.value = parseFloat($(this).data('value'));
			eventHub.publish('suggest-point-selected', [{'selectedValue' : self.value}]);
			$('div', '[data-id="item_amount_1"]').text(self.value);

			_lastEventTimestamp = currentTime;
		});

		if (this.options.data) {
			this.setData(this.options.data);
		}
	};

	Plugin.prototype.setData = function (data, currency) {
		var self = this;
		this.options.data = this.parser(data || []);
		this.listElm.empty();
		if (data.length) {
			currency = currency || self.options.currency;
			if (this.options.order === 'asc'){
				this.options.data = lo.sortBy(this.options.data);
			}
			if (this.options.order === 'desc'){
				this.options.data = lo.sortBy(this.options.data).reverse();
			}
			var internals = '<div class="trow">';
			lo.each(this.options.data, function (point, ix) {
				if (ix % this.options.pointsPerRow === 0 && ix > 0) {
					internals += '</div><div class="trow">';
				}
				var amount = parseInt(lo.escape(point), 10); // parseFloat(lo.escape(point));
				var valueLabel = self.formatter[self.options.showCurrency ? 'formatCurrency' : 'formatDecimal'](amount, currency);
				internals += '<div class="tcell spoint" data-value="' + lo.escape(point) + '">' + valueLabel + '</div>';
			}, this);
			internals += '</div>';
			this.listElm.append(internals);
		}
	};

	Plugin.prototype.setValue = function (value) {
		var index = lo.indexOf(this.options.data, value);
		this.listElm.find('.selected').removeClass('selected');

		if (index > -1) {
			this.options.onChange(this.value, value);
			this.value = value;
			this.listElm.find('[data-value="' + lo.escape(value) + '"]').addClass('selected');
		}
		else {
			this.value = value;

		}
	};
	Plugin.prototype.getValue = function () {
		return this.value;
	};
	$.fn[pluginName] = function (options) {
		return this.each(function () {
			if (!$.data(this, 'plugin_' + pluginName)) {
				$.data(this, 'plugin_' + pluginName, new Plugin(this, options));
			}
		});
	};
}(jQuery, _, pubsub));